/**
 * Identity of the current result set, ignoring pagination.
 *
 * Two calls returning the same string mean the same users match — only the window
 * into them changed. The users page needs this because paging and filtering both
 * flow through `queryParams`, so its `configChanged` check cannot tell them apart,
 * and a cross-page selection must survive the former while clearing on the latter.
 *
 * `perPage` is excluded along with `page`: changing the page size changes the
 * window, not which users match.
 *
 * @param {Object} [queryParams] The users request params.
 * @param {Object} [filters] The filter bar state.
 * @param {*} [startDate] Start of the date range, if any.
 * @param {*} [endDate] End of the date range, if any.
 * @returns {string}
 *
 * @example
 * resultSetKey({ page: 1, query: 'ada' }) === resultSetKey({ page: 3, query: 'ada' }); // true
 * resultSetKey({ query: 'ada' }) === resultSetKey({ query: 'alan' });                  // false
 */
export const resultSetKey = (queryParams = {}, filters = {}, startDate = null, endDate = null) => {
  // eslint-disable-next-line no-unused-vars
  const { page, perPage, ...rest } = queryParams;

  return JSON.stringify([rest, filters, startDate, endDate]);
};
